import { getSplitParam } from '../../../utils';
import * as CryptoJS from 'crypto-js';

// Cache for query parameter decryption and parsing to avoid expensive CryptoJS calls in loops
let cachedSearch: string | null = null;
let cachedParams: URLSearchParams | null = null;

const getDecryptedParams = (): URLSearchParams => {
  const currentSearch = typeof window !== 'undefined' && window.location ? window.location.search : '';
  if (cachedParams && cachedSearch === currentSearch) {
    return cachedParams;
  }

  const params = new URLSearchParams(currentSearch);
  const encryptedParams = params.get('params');
  if (encryptedParams) {
    try {
      const decrypted = CryptoJS.AES.decrypt(encryptedParams, 'z!!!!!!!1sdfadsf56adf456asdfasdf');
      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
      const decryptedParams = new URLSearchParams();
      if (decryptedString.trim().startsWith('{')) {
        const decryptedJson = JSON.parse(decryptedString);
        Object.entries(decryptedJson).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            decryptedParams.set(key, String(value));
          }
        });
      } else {
        const parsed = new URLSearchParams(decryptedString);
        for (const [key, value] of parsed) {
          decryptedParams.set(key, value);
        }
      }
      // Merge decrypted params into params
      for (const [key, value] of decryptedParams) {
        const existingValue = params.get(key);
        if (
          existingValue === null ||
          existingValue === '' ||
          existingValue === 'null' ||
          existingValue === 'undefined'
        ) {
          params.set(key, value);
        }
      }
    } catch (error) {
      console.error('Failed to decrypt params:', error);
    }
  }

  cachedSearch = currentSearch;
  cachedParams = params;
  return params;
};

/** Indicates if the given display set is the one specified in the
 * displaySet parameter in the URL
 * The parameters are:
 *    initialSeriesInstanceUID
 *    initialSOPInstanceUID
 */
const isDisplaySetFromUrl = (displaySet): boolean | undefined => {
  const params = getDecryptedParams();

  const initialSeriesInstanceUID = getSplitParam('initialseriesinstanceuid', params);
  const initialSOPInstanceUID = getSplitParam('initialsopinstanceuid', params);
  if (!initialSeriesInstanceUID && !initialSOPInstanceUID) {
    return false;
  }

  const isSeriesMatch = Array.isArray(initialSeriesInstanceUID)
    ? initialSeriesInstanceUID.some(
        seriesUID => displaySet?.SeriesInstanceUID === seriesUID
      )
    : undefined;

  // Use Set for O(1) lookups instead of O(M) in a nested loop for large display sets
  const sopSet = Array.isArray(initialSOPInstanceUID) ? new Set(initialSOPInstanceUID) : null;
  const isSopMatch = sopSet && displaySet?.instances
    ? displaySet.instances.some(instance => instance && sopSet.has(instance.SOPInstanceUID))
    : undefined;

  return isSeriesMatch || isSopMatch;
};

/** Returns the index location of the requested image, or the defaultValue in this.
 * Returns undefined to fallback to the defaultValue
 */
function sopInstanceLocation(displaySets) {
  const displaySet = displaySets?.[0];
  if (!displaySet || !displaySet.instances) {
    return;
  }

  const params = getDecryptedParams();

  const initialSOPInstanceUID = getSplitParam('initialsopinstanceuid', params);
  if (!initialSOPInstanceUID || !Array.isArray(initialSOPInstanceUID)) {
    return;
  }

  const sopSet = new Set(initialSOPInstanceUID);
  const index = displaySet.instances.findIndex(instance =>
    instance && sopSet.has(instance.SOPInstanceUID)
  );
  // Need to return in the initial position specified format.
  return index === -1 ? undefined : { index };
}

export { isDisplaySetFromUrl, sopInstanceLocation };
